import React from 'react';
type LogoProps = {
  tone?: 'dark' | 'light';
  showWordmark?: boolean;
  className?: string;
};

/**
 * Placeholder logo: thin gold circle with "XII" + TRUE TWELVE wordmark.
 * [NEED FROM ABBY: final logo files, SVG/PNG] — swap the <svg> below for the real mark.
 */
export function Logo({
  tone = 'dark',
  showWordmark = true,
  className = ''
}: LogoProps) {
  const color = tone === 'light' ? 'text-cream' : 'text-charcoal';
  return <span className={`inline-flex items-center gap-3 ${color} ${className}`} data-id="element-285" data-mp="mte0v260xnic">
      <svg viewBox="0 0 40 40" className="h-9 w-9 shrink-0" aria-hidden="true" data-id="element-286" data-mp="rqw6aiku1kll">
        <circle cx="20" cy="20" r="18.75" fill="none" stroke="#B8976A" strokeWidth="1" data-id="element-287" data-mp="dsxwlqhgiccf" />
        <circle cx="20" cy="20" r="15.5" fill="none" stroke="#B8976A" strokeWidth="0.4" strokeOpacity="0.7" data-id="element-288" data-mp="ht8dvzap8p6l" />
        <line x1="20" y1="1.25" x2="20" y2="4.5" stroke="#B8976A" strokeWidth="1" data-id="element-289" data-mp="2yi5h5cf25tzu" />
        <text x="20.6" y="24.4" textAnchor="middle" fontFamily="'Barlow Condensed', sans-serif" fontSize="12.5" fontWeight="400" letterSpacing="1" fill="currentColor" data-id="element-290" data-mp="32jqs2s817y7e">
          XII
        </text>
      </svg>
      {showWordmark && <span className="t-wordmark whitespace-nowrap text-[0.74rem] max-[400px]:hidden sm:text-[0.86rem]" data-id="element-291" data-mp="1nwr4eq38dnma">
          True Twelve
        </span>}
    </span>;
}